import type { FollowUpSheet, Dive } from "../followup/Followup.typed";
import type { MultiComment } from "../zekay/comments";
import type { TheoryTest } from "../theoryTests/TheoryTest.typed";
export interface TrainingTemplatesPaginationRequest {
  page?: number;
  limit?: number;
}

export interface TrainingsPaginationRequest {
  page?: number;
  limit?: number;
  template_id?: number;
  alert?: string;
}

/** POST /trainings/search body (see API: `template_id` required). */
export interface TrainingSearchRequest {
  template_id: number;
  status_code: number;
  query: string;
  page?: number;
  limit?: number;
  alert?: string;
}

export interface TrainingAlert {
  Key: string;
  Label: string;
}

export interface TrainingAlertTarget {
  view: string;
  training_template_id: number;
  status_code: number;
  alert: string;
}

/** GET /trainings/alerts item. */
export interface TrainingAlertGroup {
  key: string;
  label: string;
  short_label: string;
  training_template_id: number;
  agency: string;
  qualification: string;
  status: string;
  status_code: number;
  count: number;
  target: TrainingAlertTarget;
}

export interface TrainingsByStatusRequest extends TrainingsPaginationRequest {
  templateId: number;
  status: number;
}

export interface Card {
  Organisation: string;
  Status?: boolean;
}

export interface Cards {
  Card: Card[];
}

export interface TrainingCourse {
  ID: string;
  Name: string;
  Url: string;
  TrainingSheet?: string;
}

export interface TrainingTemplate {
  ID: number;
  Agency: string;
  Qualification: string;
  Course1Url?: string;
  Course2Url?: string;
  TestUrl?: string;
  TheoryUrl?: string;
  MedicalAgreement?: string;
  MedicalDisclaimer?: string;
  MailTemplateStartID?: number | null;
  MailTemplateAddedID?: number | null;
  MailTemplateAccessID?: number | null;
  MailTemplateEndID?: number | null;
  ZCreditID?: number;
  ZTrainingId: number;
  ZQualificationId: number;
  DestinationQualificationID?: number;
  Cards: Cards;
  IsSDI: boolean;
  NeedsTheory: boolean;
  NeedsRifap: boolean;
  TrainingCourses?: TrainingCourse[];
}

export interface CreateTrainingTemplatePayload {
  Agency: string;
  Qualification: string;
  ZCreditID?: number;
  ZTrainingId?: number;
  ZQualificationId?: number;
  DestinationQualificationID?: number;
  IsSDI?: boolean;
  NeedsTheory?: boolean;
  NeedsRifap?: boolean;
  Cards?: Cards;
}

export type ExternalProviderType = "zuurit";

export interface ExternalOptionItem {
  ID: number;
  Name: string;
}

export interface TrainingTemplateExternalOptionsResponse {
  Credits: ExternalOptionItem[];
  Qualifications: ExternalOptionItem[];
}

export interface Training {
  FirstName?: string;
  LastName?: string;
  ID?: number;
  CustomerID: number | undefined;
  Agency?: string;
  Qualification?: string;
  Status?: string;
  ZCreditID?: number;
  ZTrainingId?: number | string;
  ZQualificationId?: number | string;
  Cards?: Cards;
  Theory: string;
  TrainingSheet?: string;
  MedicalAgreement?: string;
  MedicalDisclaimer?: string;
  ValidationTest?: boolean;
  TestResult?: string;
  CreatedAt?: Date;
  UpdatedAt?: Date;
  UpdatedBy?: string;
  IsSDI?: boolean;
  NeedsTheory?: boolean;
  NeedsRifap?: boolean;
  RifapDate: string;
  CreditCount?: number;
  TheoryTests?: TheoryTest[];
  FollowUpSheet?: FollowUpSheet;
  Dives?: Dive[];
  MultiComments?: MultiComment[];
  TrainingTemplateID?: number;
  Sessions?: number;
  LastActivityAt?: Date;
  Alerts?: TrainingAlert[];
}

export enum TrainingStatusCode {
  InProgress = 1,
  Done = 2,
  Validated = 3,
  Cancelled = 4,
}

export const TRAINING_STATUS_LABELS: Record<TrainingStatusCode, string> = {
  [TrainingStatusCode.InProgress]: "En cours",
  [TrainingStatusCode.Done]: "Terminé",
  [TrainingStatusCode.Validated]: "Validé",
  [TrainingStatusCode.Cancelled]: "Annulé",
};

export interface Session {
  ID?: number;
  CustomerId?: number;
  Number?: number;
  Date?: string;
  Instructor: string;
  DiveSite?: string;
  DiveTime?: number;
  DiveDepth?: number;
  GlobalComment?: string;
  Form?: unknown;
}

export interface File {
  CustomerID: number | undefined;
  TrainingID?: number;
  Type: string | undefined;
  File?: string | Blob | File | ProgressEvent<FileReader> | undefined;
}

export interface QualificationList {
  id: number;
  name: string;
  zTrainingId: number;
  zQualificationId: number;
}

export interface Qualification {
  id: string;
  agency: string;
  QualificationList: QualificationList[];
}
